import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-key-forecast-popup-content-widget',
  templateUrl: './key-forecast-popup-content-widget.component.html',
  styleUrls: ['./key-forecast-popup-content-widget.component.scss']
})
export class KeyForecastPopupContentWidgetComponent implements OnInit, OnDestroy {
  @Output() closePopupEvent : EventEmitter<boolean> = new EventEmitter<boolean>();


  ngOnInit(): void {
    
  }

  ngOnDestroy(): void {
    
  }

  
	onCloseButtonClicked = () => {
		this.closePopupEvent.emit(true);
	} 

}
